import { Component, OnInit } from '@angular/core';
import { SessionService } from '../../shared/services/session/session.service';
import { TicketHistoryService } from '../../shared/services/ticket-history/ticket-history.service';
import { HistoryTicket } from '../../shared/domain/history-ticket';

@Component({
  selector: 'vit-ticket-history',
  templateUrl: './ticket-history.component.html',
  styleUrls: ['./ticket-history.component.scss']
})
export class TicketHistoryComponent implements OnInit {

  filter: string = 'ALL';

  get history(): HistoryTicket[] {
    if (this.filter === 'ALL') {
      return this.sessionService.history;
    }

    return this.sessionService.history.filter(hb => hb.status === this.filter);
  }

  constructor(public sessionService: SessionService,
              public ticketHistoryService: TicketHistoryService) {
  }

  ngOnInit() {
      this.ticketHistoryService.fetchHistory();
  }
}



// WEBPACK FOOTER //
// C:/Users/jenkins/AppData/Local/Jenkins/.jenkins/workspace/keno-web/vit-keno/src/app/menu-bar/ticket-history/ticket-history.component.ts